
















import { Component, Mixins } from "vue-property-decorator";
import { DeveloperQuittableMixin, DeveloperPresentableMixin } from "../mixins";

@Component({
  components: {
  }
})
export default class Overview extends Mixins(DeveloperQuittableMixin, DeveloperPresentableMixin) {
  startDeveloperMode(): void {
    this.isDeveloperMode = true;
  }
}
